<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-form-group label="Status">
          <custom-v-select
            v-model="selectedStatus"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            label="text"
            :reduce="opt => opt.value"
            placeholder="Select Status"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Credit Type">
          <custom-v-select
            v-model="selectedCreditType"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="creditTypeOptions"
            label="text"
            :reduce="opt => opt.value"
            placeholder="Select Credit Type"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Transport Type">
          <custom-v-select
            v-model="selectedTransportType"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="transportTypeOptions"
            label="text"
            :reduce="opt => opt.value"
            placeholder="Select Transport Type"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Retail App Installed">
          <custom-v-select
            v-model="retailAppInstalled"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="booleanOptions"
            label="text"
            :reduce="opt => opt.value"
            placeholder="Select"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Created By">
          <custom-v-select
            v-model="selectedCreatedBy"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="userOptions"
            label="fullname"
            placeholder="Select User"
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup,
} from 'bootstrap-vue'
import axios from 'axios'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'

export default {
  name: 'LeadFilter',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    CustomVSelect,
  },
  data() {
    return {
      selectedStatus: [],
      selectedCreditType: [],
      selectedTransportType: [],
      retailAppInstalled: null,
      selectedCreatedBy: [],
      userOptions: [],

      statusOptions: [
        { value: 'pending', text: 'Pending' },
        { value: 'success', text: 'Success' },
        { value: 'failed', text: 'Failed' },
      ],
      creditTypeOptions: [
        { value: 'cash', text: 'Cash' },
        { value: 'bill_to_bill', text: 'Bill to Bill' },
        { value: 'statement', text: 'Statement' },
      ],
      transportTypeOptions: [
        { value: 'bus', text: 'Bus' },
        { value: 'courier', text: 'Courier' },
      ],
      booleanOptions: [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' },
      ],
    }
  },
  created() {
    this.fetchUserOptions()
  },
  methods: {
    async fetchUserOptions() {
      const { data: usersList } = await axios.get('/delivery/users_list')
      this.userOptions = usersList
    },

    filtersChangeHandler() {
      const filtersdata = {}
      if (this.selectedStatus) {
        filtersdata.status = this.selectedStatus
      }
      if (this.selectedCreditType) {
        filtersdata.credit_type = this.selectedCreditType
      }
      if (this.selectedTransportType) {
        filtersdata.transport_type = this.selectedTransportType
      }
      if (this.retailAppInstalled !== null) {
        filtersdata.retail_app_installed = this.retailAppInstalled
      }
      if (this.selectedCreatedBy) {
        filtersdata.created_by = this.selectedCreatedBy.id
      }
      this.$emit('filtersUpdated', filtersdata)
    },
  },
}
</script>
